import React from 'react';
import { Check, Star, Shield } from 'lucide-react';
import { whyChooseData, trustData } from '../../data/mock';
import '../../styles/landing.css';

const WhyChooseSection = () => {
  return (
    <section className="section section-light">
      <div className="container">
        <div className="section-header">
          <div className="section-label">Ventajas</div>
          <h2 className="heading-1 section-title">{whyChooseData.title}</h2>
        </div>
        
        <div className="why-grid">
          {/* Reasons */}
          <div className="why-card">
            <div className="flex items-center gap-3 mb-6">
              <div className="w-12 h-12 bg-[#0a1628] flex items-center justify-center">
                <Star size={24} className="text-[#D4AF37]" />
              </div>
              <h3 className="heading-2">Beneficios</h3>
            </div>
            
            <ul className="why-list">
              {whyChooseData.reasons.map((reason, index) => (
                <li key={index} className="why-item">
                  <div className="why-number">{index + 1}</div>
                  <span className="body-medium">{reason}</span>
                </li>
              ))}
            </ul>
          </div>
          
          {/* Trust */}
          <div className="why-card why-card-dark">
            <div className="flex items-center gap-3 mb-6">
              <div className="w-12 h-12 border border-[#D4AF37] flex items-center justify-center">
                <Shield size={24} className="text-[#D4AF37]" />
              </div>
              <h3 className="heading-2 text-white">{trustData.title}</h3>
            </div>
            
            <ul className="why-list">
              {trustData.items.map((item, index) => (
                <li key={index} className="why-item">
                  <div className="w-8 h-8 bg-[#D4AF37] flex items-center justify-center flex-shrink-0">
                    <Check size={16} className="text-[#0a1628]" />
                  </div>
                  <span>{item}</span>
                </li>
              ))}
            </ul>
            
            <div className="mt-8 pt-6 border-t border-white/10 text-center">
              <p className="text-sm text-gray-400">
                Tu información está protegida bajo estricta confidencialidad profesional
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default WhyChooseSection;
